import { LocalStorageConstants } from "@/types/LocalStorageConstants";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { AVAILABLE_LANGUAGES, NAMESPACES } from "./languages";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: AVAILABLE_LANGUAGES.map((l) => l.locale),
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: NAMESPACES,
    defaultNS: NAMESPACES[0],
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: LocalStorageConstants.LANGUAGE,
    },
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },

    // Cache settings
    cache: {
      enabled: true,
    },
  });

export default i18n;
